<template>
  <div>
    <BaseModal v-model="deleteconfirm" title="Remove group member from the group?">
      <p>This operation will remove this group member from the group.</p>
      <template #modal-footer>
        <button class="btn btn-danger w-100 mt-3" @click="deletegroupmember(delete_id)">
          Remove from group
        </button>
        <button class="btn btn-secondary w-100 mt-2" @click="deleteconfirm=false;delete_id=0;">
          Cancel
        </button>
      </template>
    </BaseModal>

    <form novalidate @submit.prevent>
      <div class="d-flex justify-content-start mt-3">
        <button type="button" class="btn btn-primary gdq-button" @click.prevent="toggleaddmember">
          Add group member
        </button>
      </div>

      <div class="d-flex justify-content-start mt-3 w-100">
        <div v-if="addmember" class="w-100">
          <form class="bg-secondary add-member-container p-3" novalidate @submit.prevent>
            <div class="mb-3">
              <label class="form-label">Form Type</label>
              <select v-model="groupmember_formoption_id" class="form-select">
                <option v-for="option in formoptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>

            <div v-show="groupmember_formoption_id === 1" class="mb-3">
              <label class="form-label">Email address</label>
              <input
                v-model="groupmember_email"
                type="text"
                class="form-control"
                :class="{ 'g-anon': anon, 'text-danger': groupmember_email_valid === 'invalid' }"
                placeholder="Email Address"
              >
              <span v-if="groupmember_email_valid === 'invalid'" class="text-danger">Invalid or duplicate email address</span>
              <span v-else>&nbsp;</span>
            </div>

            <div class="text-end">
              <button class="btn btn-primary" type="button" @click.prevent="addgroupmember">
                <span class="d-inline-block d-md-none d-lg-inline-block">Add</span>
              </button>
              <button class="btn btn-danger ms-2" type="button" @click="toggleaddmember">
                <span class="d-inline-block d-md-none d-lg-inline-block">Cancel</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <BaseTable
        :fields="fields"
        :items="groupmembers_grid"
        :tbody-tr-class="rowClass"
        class="actions-table save-cancel mt-3"
      >
        <template #head(select)>
          <input v-model="selected" type="checkbox" @click.stop>
        </template>

        <template #cell(groupmember_email)="slotProps">
          <div class="position-relative">
            <div v-if="!slotProps.data.item.editable" class="uneditable" :class="{ 'g-anon': anon }">
              {{ slotProps.data.item.groupmember_email }}
            </div>
            <input
              v-else
              v-model="slotProps.data.item.groupmember_email"
              type="text"
              class="form-control"
              :class="{ 'g-anon': anon, 'text-danger': slotProps.data.item.groupmember_email_valid === 'invalid' }"
            >
            <i
              v-if="slotProps.data.item.groupmember_email_valid === 'invalid' && slotProps.data.item.editable"
              class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
              title="Invalid email address"
            />
          </div>
        </template>

        <template #cell(groupmember_formoption_id)="slotProps">
          <div v-if="!slotProps.data.item.editable" class="uneditable">
            {{ getFormOptionText(slotProps.data.item.groupmember_formoption_id) }}
          </div>
          <select
            v-else
            v-model="slotProps.data.item.groupmember_formoption_id"
            class="form-select"
          >
            <option v-for="option in formoptions" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </template>

        <template #cell(actions)="slotProps">
          <div class="d-flex justify-content-end">
            <div v-if="slotProps.data.item.editable">
              <button class="btn btn-danger btn-sm me-1" @click.prevent="cancelEdit(slotProps.data.item.id)">Cancel</button>
              <button class="btn btn-primary btn-sm" @click.prevent="saveEdit(slotProps.data.item.id)">Save</button>
            </div>
            <BaseDropdown right class="ms-2" variant="light">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <li>
                <button class="dropdown-item" type="button" @click.prevent="editGroupMember(slotProps.data.item.id)">Edit</button>
              </li>
              <li>
                <button class="dropdown-item" type="button" @click.prevent.stop="deleteconfirm=true;delete_id=slotProps.data.item.id">Remove from group</button>
              </li>
            </BaseDropdown>
          </div>
        </template>
      </BaseTable>
    </form>
  </div>
</template>
<script>
import BaseDropdown from './base/BaseDropdown.vue'
import BaseModal from './base/BaseModal.vue'
import BaseTable from './base/BaseTable.vue'

const fields = [
  { key: 'groupmember_code', label: 'Member', tdClass: 'col gdq-w-50px', thClass: 'col gdq-w-50px' },
  { key: 'groupmember_email', label: 'Email', tdClass: 'col', thClass: 'col' },
  { key: 'groupmember_formoption_id', label: 'Form', tdClass: 'col', thClass: 'col' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]
export default {
  components: {
    BaseDropdown,
    BaseModal,
    BaseTable
  },
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: false,
      fields,
      rows: 4,
      perPage: 3,
      currentPage: 1,
      group_id: this.$store.state.currentgroup_id,
      currentgroup: {},
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      addingmember: false,
      editingmember: 0,
      editingfield: '',
      groupmembers: [],
      groupmembers_grid: [],
      languages: [],
      formoptions: [],
      original_member_data: {},
      addmember: false,
      deleteconfirm: false,
      delete_id: 0
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    }
  },
  created () {
    this.group_get()
    this.languages_get()
    this.formoptions_get()
    this.groupmembers_get()
  },
  methods: {
    toggleaddmember () {
      this.cleargroupmember()
      this.addmember = !this.addmember
    },
    rowClass (item) {
      return item.editable ? 'editable-row' : ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    async saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      // Existing member
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        const original = this.original_member_data[id]
        const originalEmail = original.groupmember_email || ''
        if (this.validateEditedMember(member)) {
          if (member.groupmember_email !== originalEmail) {
            member.groupsurveymember_status_id = 1
            this.groupmembers_grid[index].groupsurveymember_status_id = 1
          }
          member.editable = false
          await this.$store.dispatch('groupmember_save', { groupmember: member })
          this.groupmembers_get()
          this.formchanged = false
          delete this.original_member_data[id]
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },
    validateEditedMember (member) {
      if (member.groupmember_formoption_id !== 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      } else {
        return this.parse_email(member.groupmember_email)
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(email.toLowerCase())
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_grid[index].groupmember_code = this.original_member_data[id].groupmember_code
        this.groupmembers_grid[index].groupmember_email = this.original_member_data[id].groupmember_email
        this.groupmembers_grid[index].groupmember_formoption_id = this.original_member_data[id].groupmember_formoption_id
        this.groupmembers_grid[index].editable = false
        delete this.original_member_data[id]
      }
    },
    group_get () {
      this.$store.dispatch('group_fetch')
        .then((resp) => {
          this.currentgroup = resp.data
        })
    },
    languages_get () {
      const filter = {
        language_enabled: {
          operator: '=',
          value: '1'
        }
      }
      this.$store.dispatch('languages_fetch', { filter })
        .then((resp) => {
          this.languages = resp.data.result.map((l) => {
            return {
              value: l.id,
              text: l.language_name
            }
          })
        })
    },
    formoptions_get () {
      this.$store.dispatch('formoptions_fetch')
        .then((resp) => {
          this.formoptions = resp.data.result.map((l) => {
            return {
              value: l.id,
              text: l.formoption_name
            }
          })
        })
    },
    getFormOptionText (id) {
      const option = this.formoptions.find(option => option.value === id)
      return option ? option.text : ''
    },
    groupmembers_get () {
      this.$store.dispatch('groupmembers_fetch', { group_id: this.group_id })
        .then((resp) => {
          const readmembers = resp.data.result
          const groupmembers = []
          for (let i = 0; i < readmembers.length; i++) {
            let groupmember_formoption_name = 'None'
            for (let j = 0; j < this.formoptions.length; j++) {
            if (readmembers[i].groupmember_formoption_id === this.formoptions[j].value) {
                groupmember_formoption_name = this.formoptions[j].text
              }
            }
            const groupmember = {
              id: readmembers[i].id,
              groupmember_code: readmembers[i].groupmember_code,
              groupmember_name: readmembers[i].groupmember_name,
              groupmember_email: readmembers[i].groupmember_email,
              groupmember_email_valid: null,
              groupmember_mobile: readmembers[i].groupmember_mobile,
              groupmember_formoption_id: readmembers[i].groupmember_formoption_id,
              groupmember_formoption_name,
              editable: false
            }
            groupmembers.push(groupmember)
          }
          this.groupmembers = groupmembers
          this.groupmembers_grid = groupmembers
        })
    },
    inputgroupmember (flag) {
      this.addingmember = flag
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
      this.inputgroupmember(false)
    },
    validategroupmember (email, formoption_id) {
      const result = []
      let formok = true
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (formoption_id === 1) {
        if (email === '') {
          this.groupmember_email_valid = false
          formok = false
        }
        if (!this.parse_email(email)) {
        // // eslint-disable-next-line
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
          this.groupmember_email_valid = false
          formok = false
        }
        // ------------------------------
        // Check for duplicates - e-mail
        // ------------------------------
        for (let j = 0; j < this.groupmembers.length; j++) {
          if (this.groupmembers[j].groupmember_email === email) {
            formok = false
            this.groupmember_email_valid = false
          }
        }
      }
      result.formok = formok
      return result
    },
    addgroupmember () {
      const validate =
          this.validategroupmember(
            this.groupmember_email,
            this.groupmember_formoption_id
          )
      // Here save IMMEDIATELY, POST HASTE
      if (validate.formok === true) {
        let code = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2).toUpperCase()
        code = code + Math.round(Math.random() * (9999 - 1000) + 1000, 0)
        code = this.groupmembers.length + 1
        const groupmember = {
          group_id: this.group_id,
          groupmember_email: this.groupmember_email,
          groupmember_code: code.toString(),
          groupmember_formoption_id: this.groupmember_formoption_id
        }
        this.$store.dispatch('groupmember_create', { groupmember })
          .then(() => {
            this.cleargroupmember()
            this.inputgroupmember(false)
            this.group_get()
            this.groupmembers_get()
          })
      }
    },
    deletegroupmember (id) {
      this.$store.dispatch('groupmember_delete', { id })
        .then(() => {
          this.deleteconfirm = false
          this.delete_id = 0
          this.groupmembers_get()
        })
    },
    savefield (id, fieldname, value) {
      if (!this.loading) {
        if (fieldname.indexOf('_date') !== -1) {
          value = this.format_date(value)
        }
        if (fieldname.indexOf('_time') !== -1) {
          if (value !== null && value !== '') {
            value = this.format_time(value)
          } else {
            value = '00:00'
          }
        }
        const data = {
          id,
          [fieldname]: value
        }
        this.formchanged = false
        this.$store.dispatch('groupmember_save', { groupmember: data })
      }
    }
  }
}
</script>
<style scoped>
</style>
